export const setTokenLocalStorage = (axiosConfig) => {
    const config = axiosConfig.config;
    const url = config.url;
    const data = axiosConfig.data;
    if (
        url.includes('2fa/auth/login') ||
        url.includes('auth/register') ||
        url.includes('auth/agency') ||
        url.includes('auth/reset') ||
        url.includes('auth/register/secondary') ||
        url.includes('auth/register/secondary-by-profile') ||
        (url.includes('auth/switch') && data?.switched)
    ) {
        const token = data?.token;
        const assume_token = sessionStorage.getItem('assume_token');

        if (assume_token) {
            sessionStorage.removeItem('assume_token');
        }

        if (token) {
            localStorage.setItem('token', token.access_token);
        }
    }

    if (url.includes('auth/refresh')) {
        const isLogin = data.is_login;
        const assumeToken = sessionStorage.getItem('assume_token');

        if (isLogin === true) {
            const token = data.token;

            if (assumeToken) {
                sessionStorage.setItem('assume_token', token.access_token);

                return;
            }

            localStorage.setItem('token', token.access_token);
        }
    }
};

export const getAllToken = () => {
    const token = window.localStorage.getItem('token');
    const assume_token = window.sessionStorage.getItem('assume_token');

    if (assume_token) return assume_token;
    if (token) return token;
};

export const getParserToken = () => {
    const tokenAll = getAllToken();

    if (!tokenAll) return null;

    try {
        const [, tokenData] = tokenAll.split('.');

        return JSON.parse(atob(tokenData));
    } catch (e) {
        return null;
    }
};
